import React, { Component } from 'react';
import Button from '../../CustomButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faComment } from '@fortawesome/free-solid-svg-icons';

import './index.css';
import ShareButton from '../../ShareButton';

class ImgRight extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.viewArticleClickHandler = this.viewArticleClickHandler.bind(this);
    this.shareButtonVertical = this.shareButtonVertical.bind(this);
  }

  topLayer_JC(){
    const { lang } = this.props;
    if (window.matchMedia('(min-width: 1450px)').matches) {
      if(lang==='fa'){ return 'center' }
      else {return '' }
    } else {return''}
  }

  btnIcon_FD(){
    const { lang } = this.props;
    if (window.matchMedia('(max-width: 520px)').matches) {
      return 'column'
    } else {
      if(lang==='fa'){return'row-reverse'}
      else { return'row'}
    }
  }
  
  viewArticleClickHandler(){
    this.props.onViewArticleClick(this.props.item);
  }

  shareButtonVertical(){
    if (window.matchMedia('(max-width: 520px)').matches) {
      return false;
    } else { return true }
  }


  render() {
    const { lang } = this.props;
    const { bgColor, title, headerImg, headerIcon, description, bgIconClass, likes, comments, date } = this.props.item;
    const _bgColor = bgColor ? bgColor : {leftBgClass:'bg-red', rightBgClass:'bg-white'};
    const _title = title ? title : {fa:'بدون عنوان', en:'no title'};
    const _description = description ? description : {fa:'بدون خلاصه', en:'no description'};
    const _shareButtonVertical = this.shareButtonVertical()
    return (
      <div className='bloge-content-img-right-container'>
        <div className='bloge-content-img-right-wrapper'>
          <div className={'bloge-content-img-right-left-layer ' + _bgColor.leftBgClass}></div>
          <div className={'bloge-content-img-right-right-layer ' + _bgColor.rightBgClass}></div>
          <div className='bloge-content-img-right-top-layer'>
            <div className='bloge-content-img-right-top-layer-description' style={{justifyContent: this.topLayer_JC()}}>
              <div className='bloge-content-img-right-top-ld-w' style={{textAlign:lang==='fa' ? 'right' : 'left'}}>
                <div style={{direction:lang==='fa' ? 'rtl' : 'ltr'}} className='bloge-content-img-right-top-ld-dw'>
                  <div>
                    <div className='bloge-content-img-right-top-ld-hi'>
                      <h1 style={{marginLeft: lang==='en' ? '10px':''}}>{lang==='fa' ? _title.fa : _title.en}</h1>
                      <div style={{marginLeft: lang==='fa' ? '10px':''}} className={bgIconClass? bgIconClass :'bg-red'}>
                        {headerIcon ? headerIcon : lang==="fa" ? '' : ''}
                      </div>
                    </div>
                    <div className='bloge-content-img-right-top-ld-hi'>
                      <p>{lang==='fa' ? (<span>{_description.fa}</span>) :(<span>{_description.en}</span>)}</p>
                      <div style={{marginLeft: lang==='fa' ? '10px':'',visibility:'hidden'}} className={bgIconClass? bgIconClass :'bg-red'}>
                        {headerIcon ? headerIcon : lang==="fa" ? '' : ''}
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{flexDirection:this.btnIcon_FD()}} className='bloge-content-img-right-btn-icon-sec'>
                  <div>
                    <Button onClick={this.viewArticleClickHandler} className='bloge-content-img-right-tl-button-a button-generic-style'> 
                      {lang === 'fa' ? 'ادامه مطلب' : 'View Article'} 
                    </Button>
                  </div>
                  <div className='bloge-content-img-right-tl-icon'>
                    <div>
                      <FontAwesomeIcon icon={faHeart} color="rgba(100, 100, 100, 0.2)" />
                      <span>{likes ? likes : 0} Like</span>
                    </div>
                    <div>
                      <FontAwesomeIcon icon={faComment} color="rgba(100, 100, 100, 0.2)" />
                      <span>{comments ? comments : 0}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='bloge-content-img-right-top-layer-img-wrapper'>
              {headerImg ? headerImg : lang==="fa" ? 'بدون عکس' : 'no image'}
              <div className="bloge-content-img-right-top-layer-img-shadow"></div>
            </div>
            <div className='bloge-content-img-right-release-date-wrapper'>
              {date ? date : 'no release date'}
            </div>
            <div className='bloge-content-img-right-share-button-wrapper'> 
              <ShareButton lang={lang} vertical={_shareButtonVertical}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



export default ImgRight;
